import { render } from "./8.Products.vue?vue&type=template&id=0cf10b2c&scoped=true"
import script from "./8.Products.vue?vue&type=script&lang=js"
export * from "./8.Products.vue?vue&type=script&lang=js"

import "./8.Products.vue?vue&type=style&index=0&id=0cf10b2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf10b2c"]])

export default __exports__